<template>
  <div class="footer-layout p-8 text-center md:text-left w-full">
    <div class="flex justify-center mb-12">
      <div
        class="flex flex-col items-center md:flex-row md:space-x-12 space-y-6 md:space-y-0"
      >
        <XingShareButton
          class="share-button xing-share-button md:mr-4 md:mb-0"
        />
        <FacebookShareButton class="share-button facebook-share-button" />
        <TwitterShareButton class="share-button twitter-share-button" />
      </div>
    </div>
    <ul class="md:flex flex-wrap justify-between w-full">
      <li>
        <a :href="getTrackingURL('https://www.xing.com/imprint')">Impressum</a>
      </li>
      <li><a :href="getTrackingURL('https://www.xing.com/terms')">AGB</a></li>
      <li>
        <a :href="getTrackingURL('https://privacy.xing.com/de')"
          >Datenschutz bei XING</a
        >
      </li>
      <li>
        <a
          :href="
            getTrackingURL('https://privacy.xing.com/de/datenschutzerklaerung')
          "
          >Datenschutzerklärung</a
        >
      </li>
      <li>
        <a href="javascript:void(0);" @click="openCookieConsent()">Tracking</a>
      </li>
      <li>&copy; NEW WORK SE</li>
    </ul>
  </div>
</template>

<script>
import XingShareButton from "@/components/share/XingShareButton";
import FacebookShareButton from "@/components/share/FacebookShareButton";
import TwitterShareButton from "@/components/share/TwitterShareButton";
import { addTrackingParamToURL } from "@/utils/tracking.js";

export default {
  name: "FooterLayout",
  components: {
    XingShareButton,
    FacebookShareButton,
    TwitterShareButton,
  },
  methods: {
    openCookieConsent() {
      window.CookieConsent.show();
    },
    getTrackingURL(url) {
      return addTrackingParamToURL(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-layout {
  color: #5e737d;
}

ul li {
  @apply mb-4 mr-0;

  & a:hover {
    @apply underline;
  }
}

@screen md {
  ul li {
    @apply mb-0 mr-4;
  }
}
</style>
